import { LANDING_ROUTE, SIGN_IN_ROUTE, SIGNUP_ROUTE } from "_constants";
import { lazy } from "react";

const Landing = lazy(() => import("pages/auth/landing"));
const SignUp = lazy(() => import("pages/auth/sign-up"));
const SIGNIN = lazy(() => import("pages/auth/sign-in"));

export const authRoutes = [
  { path: LANDING_ROUTE, element: <Landing /> },
  { path: SIGNUP_ROUTE, element: <SignUp /> },
  { path: SIGN_IN_ROUTE, element: <SIGNIN /> },
];
